import classNames from "classnames";
import React from "react";
import classes from "./FooterText.scss";
import { Button } from "@toddle-edu/ds-web";
import { Trans } from "react-i18next";
import { colors } from "Constants";
import { isPortfolioFilterRevamp } from "Post/utils";

const boldTextStyle = { padding: "0 4px", fontWeight: "600" };
const likedByFontStyle = {
  color: colors.textSubtle,
  fontWeight: "600",
  padding: "0 0 0 4px",
};

const likedByFontStyleV2 = {
  color: "var(--neutral-400)",
  fontWeight: "600",
  padding: "0 0 0 4px",
};

const boldButtonStyle = { padding: "0 0 0 4px", background: "transparent" };
const boldButtonStyleV2 = {
  padding: "0 0 0 4px",
  background: "transparent",
  color: colors.textSubtle,
};
export const FooterText = React.memo(props => {
  const {
    likedByName = "",
    likesCount = 0,
    commentsCount = 0,
    viewsCount = 0,
    toggleLikeModal,
    toggleViewsModal,
    showCommentsPane,
    showViews = false,
    userType,
    t,
    showLike = true,
    showComment = true,
    showNewDesign = false,
    showNewDesignV2 = false,
    isSidePaneContent = false,
  } = props;

  const showDotBeforeViews = likesCount > 0;
  const showDotBeforeComments = likesCount > 0 || (showViews && viewsCount > 0);

  const likedByLocale =
    likesCount - 1 === 1
      ? "journal:liked_by_name_and_other"
      : "journal:liked_by_name_and_others";
  const viewsLocale =
    viewsCount === 1 ? "journal:views_count" : "journal:views_count_plural";
  const commentsLocale =
    commentsCount === 1
      ? "journal:comments_count"
      : "journal:comments_count_plural";

  const buttonClass = classNames({
    [classes.countContainer]: !showNewDesign && !showNewDesignV2,
    [classes.clickableText]: !showNewDesign && !showNewDesignV2,
    [classes.countContainerV2]: showNewDesign && !showNewDesignV2,
    [classes.clickableTextV2]: showNewDesign && !showNewDesignV2,
    [classes.countContainerV3]: showNewDesignV2,
    [classes.clickableTextV3]: showNewDesignV2,
  });

  const countContainerClass = classNames({
    [classes.countContainerV2]: showNewDesign && !showNewDesignV2,
    [classes.countContainerV3]: showNewDesignV2,
    [classes.countContainer]: !showNewDesign && !showNewDesignV2,
  });
  const likedByStyle = isPortfolioFilterRevamp()
    ? likedByFontStyleV2
    : showNewDesign
    ? likedByFontStyle
    : boldTextStyle;

  return (showLike && likesCount > 0) ||
    (showComment && commentsCount > 0) ||
    (showViews && viewsCount > 0) ? (
    <div
      className={classes.container}
      style={{
        marginTop:
          showNewDesign && !isSidePaneContent
            ? showNewDesignV2
              ? "12px"
              : "16px"
            : "",
        marginBottom: showNewDesign && isSidePaneContent ? "16px" : "",
      }}
    >
      {showLike && likesCount > 1 && (
        <div
          data-test-id="journal-postcard-liketext-container"
          className={countContainerClass}
        >
          <Trans i18nKey={likedByLocale}>
            <span style={{ ...likedByStyle, padding: "0px 4px" }}>
              {{ name: likedByName }}
            </span>
            {userType === "staff" ? (
              <Button
                style={showNewDesign ? boldButtonStyleV2 : boldButtonStyle}
                onClick={() => toggleLikeModal(true)}
                className={
                  showNewDesign
                    ? classes.clickableTextV2
                    : classes.clickableText
                }
                variant={showNewDesign ? "plain" : "on"}
                size="small"
                testId="journal-postcard-liketext"
              >
                {{ likesCount: likesCount - 1 }}
              </Button>
            ) : (
              <span style={likedByStyle}>{{ likesCount: likesCount - 1 }}</span>
            )}
          </Trans>
        </div>
      )}
      {showLike && likesCount === 1 && (
        <div
          data-test-id="journal-postcard-liketext-container"
          className={countContainerClass}
        >
          <span style={likedByStyle}>
            {t("journal:liked_by_singular", { name: likedByName })}
          </span>
        </div>
      )}

      {showViews && viewsCount > 0 && (
        <React.Fragment>
          {showDotBeforeViews && (
            <div className={classes.dotContainer}>
              <div className={classes.dot}></div>
            </div>
          )}
          <Button
            style={{ fontWeight: "600", padding: "0" }}
            className={buttonClass}
            onClick={() => toggleViewsModal(true)}
            variant="on"
            size="small"
            testId="journal-postcard-viewtext"
          >
            {showNewDesign ? (
              <span style={likedByStyle}>
                {t(viewsLocale, { count: viewsCount })}
              </span>
            ) : (
              t(viewsLocale, { count: viewsCount })
            )}
          </Button>
        </React.Fragment>
      )}

      {showComment && commentsCount > 0 && (
        <React.Fragment>
          {showDotBeforeComments && (
            <div className={classes.dotContainer}>
              <div className={classes.dot}></div>
            </div>
          )}
          <Button
            style={{ fontWeight: "600", padding: "0" }}
            className={buttonClass}
            onClick={() => showCommentsPane()}
            variant={showNewDesign ? "plain" : "on"}
            type="inline"
            size="small"
            testId="journal-postcard-commenttext"
          >
            {t(commentsLocale, { count: commentsCount })}
          </Button>
        </React.Fragment>
      )}
    </div>
  ) : null;
});

FooterText.displayName = "FooterText";
